import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5a37cffe"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "step-content" }

import modalBase from "@/components/ui/modals/modal-base.vue";
import { computed, onMounted, ref, watch, nextTick } from "vue";
import { ModalWidth } from "@/types/ui/modals/ModalWidth";
import { DxToolbarItem } from "devextreme-vue/popup";
import { PaymentRunListItem } from "@/types/accounts/PaymentRunListItem";
import { UserPermissions } from "@/types/user/permissions/UserPermissions";
import { useUserPermissionsStore } from "@/stores/UserPermissionsStore";
import { PaymentMethod } from "@/enums/tenancies/PaymentMethod";
import { PaymentRunsToProcess } from "@/types/accounts/PaymentRunsToProcess ";
import { PaymentRunContactAPIFilters } from "@/types/accounts/PaymentRunContactAPIFilters";
import { ContextMenuItem } from "@/types/ui/menus/ContextMenuItem";
import { DxTabPanel, DxItem } from "devextreme-vue/tab-panel";
import {
  ProcessedPaymentRun,
  Payment,
} from "@/types/accounts/ProcessedPaymentRun";
import { displayQuestionAlert } from "@/alerts/questionAlert";
import { BankAccounts } from "@/enums/accounts/BankAccounts";
import { PaymentExportFormat } from "@/enums/accounts/PaymentExportFormat";
import { PaymentRunContactType } from "@/enums/contacts/PaymentRunContactType";
import SetPaymentRunModal from "@/components/payment-runs/set-payment-run-modal.vue";
import { useContactHelper } from "@/utils/contacts/useContactHelper";
import { PreferredDeliveryMethod } from "@/enums/financials/ContactType";
import { useFinancialHelper } from "@/utils/financials/useFinancialHelper";
import displayErrorMessage from "@/utils/ErrorHandling";
import PaymentRunStepOneGrid from "@/components/payment-runs/payment-run-step-one.vue";
import PaymentRunStepTwo from "@/components/payment-runs/payment-run-step-two.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'payment-run-modal',
  props: {
  /**
   * The boolean value used with `v-model` to control the visibility or state of a modal or component.
   * @type {boolean}
   * @required
   */
  modelValue: {
    type: Boolean,
    required: true,
  },
},
  emits: [
  /**
   * Triggered when the `modelValue` changes. This is used to update the v-model variable in the parent component.
   * @property {boolean} value - Indicates whether the modal has been opened or closed.
   */
  "update:modelValue",
],
  setup(__props, { emit }) {

const props = __props;





const showModal = computed({
  get: () => props.modelValue,
  set: (value: boolean) => emit("update:modelValue", value),
});

const onCancelClick = () => (showModal.value = false);
const selectedPayment = ref<PaymentRunListItem>();
const payments = ref<PaymentRunListItem[]>([]);
const loading = ref(false);
const showEditReceivedModal = ref(false);
const userPermissionStore = useUserPermissionsStore();
const currentUserPermissions = ref<UserPermissions>();
const selectedFilters = ref<PaymentRunContactAPIFilters>({
  bankAccountId: BankAccounts.GweClient,
  siteId: -1,
  onlyIncludeWithBankAccounts: false,
  landlordId: -1,
  contactType: PaymentRunContactType.Landlord,
  paymentExportFormat: PaymentExportFormat.Generic,
});
const paymentMethod = ref(PaymentMethod.StandingOrder);
const disableAllButtons = ref(false);
const contactTypeDescription = ref("");
const bankAccountDescription = ref("");
const paymentDate = ref(new Date().toISOString());
const preferredDeliveryMethodsToBeUsed = ref(true);
const processedPaymentRun = ref<ProcessedPaymentRun>();
const selectedTab = ref(0);
const processSuccessful = ref(false);
const cancelConfirmationText = computed(() => {
  return processSuccessful.value
    ? "Were your statements correct and have they been successfuly produced?"
    : "";
});
const showCloseConfirmationPrompt = ref(false);
const filesToEmail = ref<File[]>([]);
const contextMenuId = ref("payment-run-modal-grid");
const exportGrid = ref(false);
const displaySetPaymentRunModal = ref(false);
const contactHelper = useContactHelper();
const numberOfContactsToEmail = ref(0);
const numberOfContactsToPost = ref(0);
const enableEmailButton = ref(false);
const enableButtonPrintForPosting = ref(false);
const summaryStatementsPostingList = ref<Payment[]>([]);
const summaryStatementsEmailList = ref<Payment[]>([]);
const selectedContactIds = ref<number[]>([]);
const contactIds = computed<number[]>(() => {
  return summaryStatementsEmailList.value.map((item) => item.contactId);
});
const propertyIds = computed<number[]>(() => {
  return summaryStatementsEmailList.value.map((item) => item.propertyId);
});
const atLeastOnePaymentSelected = computed(() => {
  return payments.value.some((payment) => payment.include);
});
const financialHelper = useFinancialHelper();

// Data fetching
onMounted(async () => {
  currentUserPermissions.value = await userPermissionStore.getUserPermissions();
});

watch(
  () => showModal.value,
  () => {
    if (!showModal.value) {
      return;
    }

    processSuccessful.value = false;
    showCloseConfirmationPrompt.value = false;
    selectedTab.value = 0;
    numberOfContactsToEmail.value = 0;
    numberOfContactsToPost.value = 0;
    enableEmailButton.value = false;
    enableButtonPrintForPosting.value = false;
    preferredDeliveryMethodsToBeUsed.value = true;
    contextMenuId.value = `payment-run-modal-grid-${Date.now()}`;
    processedPaymentRun.value = undefined;
    fetchAndHandleData();
  },
);

watch(
  () => selectedFilters.value,
  () => {
    fetchAndHandleData();
  },
  { deep: true },
);

const fetchAndHandleData = async () => {
  loading.value = true;
  const initialPayments: PaymentRunListItem[] =
    await financialHelper.fetchPayments(fetchPaymentsFilters.value);
  payments.value = initialPayments.map((payment: PaymentRunListItem) => {
    return {
      ...payment,
      include: false,
      pause: false,
    };
  });

  if (selectedContactIds.value.length > 0) {
    payments.value = payments.value.map((payment) => {
      if (selectedContactIds.value.includes(payment.contactId)) {
        payment.include = true;
      }
      return payment;
    });
  }
  selectedPayment.value = undefined;
  loading.value = false;
};

const fetchPaymentsFilters = computed(() => {
  const filters = new PaymentRunContactAPIFilters();
  filters.bankAccountId = selectedFilters.value.bankAccountId;
  filters.siteId = selectedFilters.value.siteId;
  filters.onlyIncludeWithBankAccounts =
    selectedFilters.value.onlyIncludeWithBankAccounts;
  filters.landlordId = selectedFilters.value.landlordId;
  filters.contactType = selectedFilters.value.contactType;
  filters.paymentExportFormat = selectedFilters.value.paymentExportFormat;
  return filters;
});

// Filter descriptions selected
const contactTypeSelected = (selectedDescription: string) => {
  contactTypeDescription.value = selectedDescription;
};

const bankAccountSelected = (selectedDescription: string) => {
  bankAccountDescription.value = selectedDescription;
};

// Row click handling
const onRowClick = (e: PaymentRunListItem) => {
  if (!e) {
    return;
  }

  selectedPayment.value = e;
  showEditReceivedModal.value = true;
};

const onRowSelected = (e: PaymentRunListItem) => {
  if (!e) {
    return;
  }

  selectedPayment.value = e;
};

// Grid menu
const menuItems = computed(() => {
  const menu: ContextMenuItem[] = [
    {
      text: "Tick All",
      key: "tickAll",
      disabled: false,
      icon: "far fa-square-check",
    },
    {
      text: "Untick All",
      key: "untickAll",
      disabled: false,
      icon: "far fa-square",
    },
    {
      text: "Set Float Amount",
      key: "setFloat",
      icon: "",
      disabled: !selectedPayment.value || loading.value,
    },
    {
      text: "Pause/Unpause Payments",
      key: "pausePayments",
      icon: "",
      disabled: !selectedPayment.value || loading.value,
    },
    {
      text: "Payment Summary Report",
      key: "paymentSummary",
      disabled: !selectedPayment.value || loading.value,
      icon: "",
    },
    {
      text: "Refresh",
      key: "refresh",
      icon: "fas fa-redo",
    },
    {
      text: "Export to Excel",
      key: "export",
      icon: "fas fa-download",
    },
  ];
  return menu;
});

const onMenuItemClick = (e: any) => {
  let index = -1;
  switch (e) {
    case "untickAll":
      payments.value = payments.value.map((payment) => {
        payment.include = false;
        return { ...payment };
      });
      break;
    case "tickAll":
      payments.value = payments.value.map((payment) => {
        payment.include = true;
        return { ...payment };
      });
      break;
    case "export":
      exportGrid.value = true;
      break;
    case "refresh":
      fetchAndHandleData();
      break;
    case "pausePayments":
      index = selectedPayment.value?.id ?? -1;
      if (index != -1 && payments.value[index]) {
        payments.value[index].pause = !payments.value[index].pause;
      }
      break;
    case "setFloat":
      displaySetPaymentRunModal.value = true;
      break;
    case "paymentSummary":
      generatePaymentSummaryReport();
      break;
    default:
      break;
  }
};

const generatePaymentSummaryReport = async () => {
  loading.value = true;
  const file: Blob | undefined =
    await financialHelper.fetchPaymentRunSummaryReport({
      bankAccountId: selectedFilters.value.bankAccountId,
      paymentRuns: payments.value
        .filter((payment) => payment.include)
        .map((payment) => {
          return {
            contactID: payment.contactId,
            propertyID: payment.propertyId,
          };
        }),
    });

  if (!file) {
    return;
  }

  // Create url
  const url = window.URL.createObjectURL(file);

  // Link allows us to download the pdf
  const link = document.createElement("a");
  link.href = url;
  link.setAttribute("download", `payment-run-statment-${Date.now()}.pdf`);
  document.body.appendChild(link);
  link.click();

  // Clears memory
  link.remove();
  window.URL.revokeObjectURL(url);
  loading.value = false;
};

// Processes the selected payments
const onRunClick = async () => {
  const processConfirmation = await displayQuestionAlert(
    "Are you sure you want to do this?",
  );

  if (!processConfirmation.isConfirmed) {
    return;
  }

  if (
    !(await financialHelper.checkBankDetails(
      selectedFilters.value.paymentExportFormat,
      selectedFilters.value.bankAccountId,
    ))
  ) {
    displayErrorMessage(
      "The bank details for the selected payment exported file are not present and valid.",
    );
    return;
  }

  loading.value = true;
  processedPaymentRun.value = await financialHelper.processPayments(
    paymnetsToProcess.value,
  );
  if (!processedPaymentRun.value) {
    loading.value = false;
    return;
  }
  showCloseConfirmationPrompt.value = true;
  await processDataForStep2();
  processSuccessful.value = true;
  selectedTab.value = 1;
  for (let i = 0; i < processedPaymentRun.value?.payments.length; i++) {
    const pdf: Blob | undefined = await financialHelper.downloadPaymentRuns({
      bankAccountId: selectedFilters.value.bankAccountId,
      allForFiling: true,
      contactType: selectedFilters.value.contactType,
      usePreferredDeliveryMethod: preferredDeliveryMethodsToBeUsed.value,
      payments: [
        {
          contactId: processedPaymentRun.value?.payments[i].contactId,
          propertyId: processedPaymentRun.value?.payments[i].propertyId,
          statementId: processedPaymentRun.value?.payments[i].statementId,
        },
      ],
    });

    if (pdf) {
      const file = new File(
        [pdf],
        `payment-run-${processedPaymentRun.value?.payments[i].statementId}.pdf`,
        {
          type: "application/pdf",
        },
      );

      filesToEmail.value.push(file);
    }
  }
  loading.value = false;
};

const paymnetsToProcess = computed(() => {
  const data: PaymentRunsToProcess = {
    paymentMethodId: paymentMethod.value,
    bankAccountId: selectedFilters.value.bankAccountId,
    bankAccountDescription: bankAccountDescription.value,
    paymentExportFormat: selectedFilters.value.paymentExportFormat,
    contactTypeId: selectedFilters.value.contactType,
    contactTypeDescription: contactTypeDescription.value,
    paymentDate: paymentDate.value,
    processingDate: new Date().toISOString(),
    items: payments.value
      .filter((payment) => {
        return payment.include;
      })
      .map((payment) => {
        return {
          amountToPay: payment.amountToPay,
          contactId: payment.contactId,
          propertyId: payment.propertyId,
          ownerId: payment.ownerId,
          taxDeduction: payment.taxToDeduct,
          referenceChequeNo: payment.referenceChequeNo,
          balance: payment.balance,
          invoiceFeesTotal: payment.invoiceFeesTotal,
          invoiceFeesSeparately: payment.invoiceFeesSeparately,
        };
      }),
  };
  return data;
});

const processDataForStep2 = async () => {
  if (!processedPaymentRun.value) {
    return;
  }

  summaryStatementsEmailList.value = [];
  summaryStatementsPostingList.value = [];

  for (const item of processedPaymentRun.value.payments) {
    const contactItem = await contactHelper.fetchContactById(item.contactId);

    if (contactItem) {
      const hasEmail = contactItem.email && contactItem.email !== "";
      const method = contactItem.preferredDeliveryMethod;

      if (hasEmail) {
        if (
          method === PreferredDeliveryMethod.Email ||
          method === PreferredDeliveryMethod.EmailPrint
        ) {
          numberOfContactsToEmail.value++;
          summaryStatementsEmailList.value = [
            ...summaryStatementsEmailList.value,
            item,
          ];
        }
        if (
          method === PreferredDeliveryMethod.Print ||
          method === PreferredDeliveryMethod.EmailPrint
        ) {
          numberOfContactsToPost.value++;
          summaryStatementsPostingList.value = [
            ...summaryStatementsPostingList.value,
            item,
          ];
        }
      } else {
        // No email so post only
        numberOfContactsToPost.value++;
      }
    }
  }

  if (numberOfContactsToPost.value > 0) {
    processSuccessful.value = true;
  } else {
    enableButtonPrintForPosting.value = false;
  }

  if (numberOfContactsToEmail.value > 0) {
    enableEmailButton.value = true;
  } else {
    enableEmailButton.value = false;
  }

  selectedTab.value = 1;
};

// After processing the payments, if the user closes the modal without confirming the files were generated correctly, the payments are undone
const cancelConfirmationModalDenied = async () => {
  selectedContactIds.value = payments.value
    .filter((payment) => {
      return payment.include;
    })
    .map((payment) => {
      return payment.contactId;
    });
  await financialHelper.undoPaymentRuns(
    processedPaymentRun.value?.paymentRunId ?? -1,
  );
  nextTick();
  showCloseConfirmationPrompt.value = false;
  showModal.value = false;
};

const cancelConfirmationModalAccepted = () => {
  selectedContactIds.value = [];
};

// Updates the float amount for the selected row
const newFloatEntered = (newFloat: number) => {
  if (!selectedPayment.value) {
    return;
  }

  selectedPayment.value.floatToRetain = newFloat;
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(modalBase, {
      modelValue: showModal.value,
      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((showModal).value = $event)),
      title: "Payment Run",
      height: "780px",
      width: _unref(ModalWidth).XLarge,
      showCloseConfirmationPrompt: showCloseConfirmationPrompt.value,
      "custom-close-confirmation-text": cancelConfirmationText.value,
      onCancelPromptDenied: cancelConfirmationModalDenied,
      onCancelPromptAccepted: cancelConfirmationModalAccepted
    }, {
      content: _withCtx(() => [
        _createVNode(_unref(DxTabPanel), {
          ref: "headerTabPanelRef",
          "scroll-by-content": true,
          "show-nav-buttons": true,
          "swipe-enabled": false,
          selectedIndex: selectedTab.value,
          "onUpdate:selectedIndex": _cache[5] || (_cache[5] = ($event: any) => ((selectedTab).value = $event))
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(DxItem), { title: "Step 1" }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_1, [
                  _createVNode(PaymentRunStepOneGrid, {
                    filters: selectedFilters.value,
                    "onUpdate:filters": _cache[0] || (_cache[0] = ($event: any) => ((selectedFilters).value = $event)),
                    payments: payments.value,
                    loading: loading.value,
                    exportGrid: exportGrid.value,
                    "onUpdate:exportGrid": _cache[1] || (_cache[1] = ($event: any) => ((exportGrid).value = $event)),
                    processSuccessful: processSuccessful.value,
                    onRowSingleClick: onRowSelected,
                    onRowDoubleCLick: onRowClick,
                    paymentMethod: paymentMethod.value,
                    "onUpdate:paymentMethod": _cache[2] || (_cache[2] = ($event: any) => ((paymentMethod).value = $event)),
                    menuItems: menuItems.value,
                    onMenuItemSelected: onMenuItemClick,
                    onContactTypeSelected: contactTypeSelected,
                    paymentDate: paymentDate.value,
                    "onUpdate:paymentDate": _cache[3] || (_cache[3] = ($event: any) => ((paymentDate).value = $event)),
                    onBankAccountSelected: bankAccountSelected
                  }, null, 8, ["filters", "payments", "loading", "exportGrid", "processSuccessful", "paymentMethod", "menuItems", "paymentDate"])
                ])
              ]),
              _: 1
            }),
            _createVNode(_unref(DxItem), { title: "Step 2" }, {
              default: _withCtx(() => [
                _createVNode(PaymentRunStepTwo, {
                  filters: selectedFilters.value,
                  processSuccessful: processSuccessful.value,
                  enableEmailButton: enableEmailButton.value,
                  enableButtonPrintForPosting: enableButtonPrintForPosting.value,
                  numberOfContactsToEmail: numberOfContactsToEmail.value,
                  numberOfContactsToPost: numberOfContactsToPost.value,
                  processedPaymentRun: processedPaymentRun.value,
                  preferredDeliveryMethodsToBeUsed: 
              preferredDeliveryMethodsToBeUsed.value
            ,
                  "onUpdate:preferredDeliveryMethodsToBeUsed": _cache[4] || (_cache[4] = ($event: any) => ((
              preferredDeliveryMethodsToBeUsed.value
            ) = $event)),
                  contactIds: contactIds.value,
                  propertyIds: propertyIds.value,
                  filesToEmail: filesToEmail.value
                }, null, 8, ["filters", "processSuccessful", "enableEmailButton", "enableButtonPrintForPosting", "numberOfContactsToEmail", "numberOfContactsToPost", "processedPaymentRun", "preferredDeliveryMethodsToBeUsed", "contactIds", "propertyIds", "filesToEmail"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["selectedIndex"])
      ]),
      footer: _withCtx(() => [
        _createVNode(_unref(DxToolbarItem), {
          widget: "dxButton",
          toolbar: "bottom",
          location: "after",
          options: {
          text: 'Run',
          onClick: () => {
            onRunClick();
          },
          disabled:
            !currentUserPermissions.value?.financialOptions.paymentrun ||
            !atLeastOnePaymentSelected.value ||
            loading.value ||
            disableAllButtons.value ||
            processSuccessful.value,
        }
        }, null, 8, ["options"]),
        _createVNode(_unref(DxToolbarItem), {
          widget: "dxButton",
          toolbar: "bottom",
          location: "after",
          options: {
          text: 'Close',
          onClick: () => {
            onCancelClick();
          },
        }
        }, null, 8, ["options"])
      ]),
      _: 1
    }, 8, ["modelValue", "width", "showCloseConfirmationPrompt", "custom-close-confirmation-text"]),
    (selectedPayment.value)
      ? (_openBlock(), _createBlock(SetPaymentRunModal, {
          key: 0,
          modelValue: displaySetPaymentRunModal.value,
          "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((displaySetPaymentRunModal).value = $event)),
          onNewFloatEntered: newFloatEntered,
          "initial-value": selectedPayment.value.floatToRetain
        }, null, 8, ["modelValue", "initial-value"]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})